<template>
  <Modal 
    :id="'cmp-accounting-invoice-royalty_period_modal'"
    @cancelled="onCancel"
  >
    
    <template slot="header">{{ $t('royalty_account') }}</template>
    <template slot="body">
      <table class="dt-table2 contact-table">
       <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
                        'margin-right': hRowMarginRight
                    }"
          >
            <th class="dt-table2--column">{{ $t('royalty_account') }}</th>
            <th class="dt-table2--column">{{ $t('start_date') }}</th>
            <th class="dt-table2--column">{{ $t('end_date') }}</th>
          
          </tr>
        </thead>
        <tbody class="dt-table2--body">
        <tr
            class="dt-table2--row"
            v-for="item in royaltyPeriods"
            :key="item.royalty_period_id"
          
          >
            <td class="dt-table2--column">{{item['royalty_account_name']}}</td>
            <td class="dt-table2--column">{{item['start_date']}}</td>
            <td class="dt-table2--column">{{item['end_date']}}</td>
         
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
    </template>

  </Modal>
</template>

<script>

import { Subject } from "rxjs";

import Modal from '../../../../dt-plugins/modal/modal';


export default {
  props: {
    
    royaltyPeriods: {
      required: true,
    },
  },
  components: {
    Modal
  },
  mixins: [
 
  ],

  data: function() {
    return {
    };
  },
  mounted:async function() {

  },
  computed: {

    
    hRowMarginRight: function() {
      if (this.royaltyPeriods.length > 380 / 28) {
        return "28px";
      }
    },
  
   
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
  }
};


</script>

<style lang="scss" >
.cmp-accounting-invoice-royalty_period_modal {
  th.dt-table2--column {
    padding:0px 12px;
  }
 td.dt-table2--column {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:0px 12px;
  
  }
}
</style>